<template>
  <div class="empadronamiento__intro__main">
    <div class="empadronamiento__intro__main__form">
      <div class="empadronamiento__intro__main__form__container">
        <form @submit.prevent>
          <fieldset>
            <div class="empadronamiento__intro__main__form__container-header">
              <p>FORMULARIO DE DECLARACIÓN DE ALQUILER</p>
            </div>
            <p class="empadronamiento__form_header_info_text" style="text-align:justify;">
              Por favor, seleccione la unidad que declarará como en alquiler e ingrese los datos de el o los titulares
              del
              contrato para comenzar. Una vez iniciado el trámite, el locatario recibirá un correo con la solicitud para
              continuar con el proceso de Empadronamiento para asociarse a la unidad.
            </p>

            <div class="base-select loading-animation" v-if="loading"></div>
            <base-select v-else v-model="NeighborhoodId" @input="getUnits" placeholder="Barrio"
              :options="Neighborhoods" />

            <div class="base-select loading-animation" v-if="loadingUnit"></div>
            <base-select v-if="NeighborhoodId !== null && !loadingUnit" v-model="RentModel.UnitId"
              placeholder="Unidad *" :options="Units" :invalid="$v.RentModel.UnitId.$invalid && submitted" />
          </fieldset>

          <fieldset>
            <div class="empadronamiento__intro__main__form__container-header">
              <p>Contrato</p>
            </div>

            <div class="base-select loading-animation" v-if="loading"></div>
            <base-select v-else v-model="RentModel.ContractType" placeholder="Tipo de contrato *"
              :options="Enums.ContractType" :invalid="$v.RentModel.ContractType.$invalid && submitted" />
            <p class="empadronamiento__intro__main__form__container__notes" v-if="RentModel.ContractType == 1">El
              periodo
              de alquiler temporal debe ser mayor a 30 días y menor a 90 días</p>
            <p class="empadronamiento__intro__main__form__container__notes" v-if="RentModel.ContractType == 2">El
              periodo
              de alquiler permanente debe ser mayor a 90 días</p>
            <base-date-picker v-model="RentModel.ContractDateFrom" :label="'Desde *'"
              :invalid="$v.RentModel.ContractDateFrom.$invalid && submitted" />

            <base-date-picker v-model="RentModel.ContractDateTo" :label="'Hasta *'" :minDate="MinToDate"
              :maxDate="MaxToDate"
              :invalid="($v.RentModel.ContractDateTo.$invalid || dateToIsInvalid()) && submitted" />
          </fieldset>

          <fieldset v-for="(titular, i) in RentModel.Titulars" :key="i">
            <template v-if="titular.PersonTypeId == 1">
              <div class="empadronamiento__intro__main__form__container-header space-between">
                <p>Información del locatario titular</p>
                <p class="delete" v-if="i > 0" @click="deleteTitular(i)">Eliminar</p>
              </div>
              <base-select placeholder="Tipo de persona *" v-model="titular.PersonTypeId"
                :options="Enums.ProcedureTitularPersonType"
                :invalid="$v.RentModel.Titulars.$each[i].PersonTypeId.$invalid && submitted" 
                :disabled="isSecondPhysicalLocked(i)"
                 @input="
                  (prop) => {
                    onPersonTypeChange(prop, i);
                  }
                "
                />
              <base-select v-if="LegalTitulars.length > 0" placeholder="Persona juridica relacionada *"
                v-model="titular.RelatedLegalTitular" :options="LegalTitulars" :invalid="false" />
              <base-input v-model.trim="titular.FirstName" name="Nombre *" placeholder="Nombre *"
                :invalid="$v.RentModel.Titulars.$each[i].FirstName.$invalid && submitted" />
              <base-input v-model.trim="titular.LastName" name="Apellido *" placeholder="Apellido *"
                :invalid="$v.RentModel.Titulars.$each[i].LastName.$invalid && submitted" />
              <base-input v-model.trim="titular.Email" name="Mail *" placeholder="Mail del nuevo locatario *"
                :invalid="$v.RentModel.Titulars.$each[i].Email.$invalid && submitted" />

              <base-input v-model.trim="titular.Phone" name="Telefono *" placeholder="Telefono *"
                :invalid="$v.RentModel.Titulars.$each[i].Phone.$invalid && submitted" />

              <base-select v-if="titular.PersonTypeId == 1" placeholder="Tipo de documento *"
                v-model="titular.IdentificationTypeId" :options="Enums.IdentificationType"
                :invalid="titular.PersonTypeId == 1 && titular.IdentificationType == '' && submitted" />

              <base-input v-if="titular.PersonTypeId == 1"
                :placeholder="isDNI(titular.IdentificationTypeId) ? 'Documento * (ej: 35960655)' : 'Pasaporte * (ej: AA123456)'"
                :value="titular.Identification"
                @input="val => { titular.Identification = normalizeDoc(val, titular.IdentificationTypeId) }"
                @blur="val => { titular.Identification = normalizeDoc(val, titular.IdentificationTypeId) }"
                :invalid="(titular.PersonTypeId == 1 && titular.Identification == '' && submitted) || (submitted && !!docFormatError(titular.Identification, titular.IdentificationTypeId))" />
              <small v-if="submitted && docFormatError(titular.Identification, titular.IdentificationTypeId)" style="color:red;">
                {{ docFormatError(titular.Identification, titular.IdentificationTypeId) }}
              </small>
            </template>

            <template v-if="titular.PersonTypeId == 2">
              <div class="empadronamiento__intro__main__form__container-header space-between">
                <p>Información del inquilino</p>
                <p class="delete" v-if="i > 0" @click="deleteTitular(i)">Eliminar</p>
              </div>
              <base-select placeholder="Tipo de persona *" v-model="titular.PersonTypeId"
                :options="Enums.ProcedureTitularPersonType"
                :invalid="$v.RentModel.Titulars.$each[i].PersonTypeId.$invalid && submitted"
                :disabled="isSecondPhysicalLocked(i)" 
                 @input="
                  (prop) => {
                    onPersonTypeChange(prop, i);
                  }
                "
                />
              <base-input v-model.trim="titular.FirstName" name="Razon Social *" placeholder="Razon Social *"
                :invalid="$v.RentModel.Titulars.$each[i].FirstName.$invalid && submitted" />
              <base-input v-model.trim="titular.LastName" name="Nombre de fantasía *" placeholder="Nombre de fantasía *"
                :invalid="$v.RentModel.Titulars.$each[i].LastName.$invalid && submitted" />
              <base-input v-model.trim="titular.Email" name="Mail *" placeholder="Mail *"
                :invalid="$v.RentModel.Titulars.$each[i].Email.$invalid && submitted" />

              <base-input v-model.trim="titular.Phone" name="Telefono *" placeholder="Telefono *"
                :invalid="$v.RentModel.Titulars.$each[i].Phone.$invalid && submitted" />

              <base-input v-if="titular.PersonTypeId == 2" placeholder="CUIT *"
                :value="titular.CUIL"
                @input="val => { titular.CUIL = val.replace(/\D/g, '') }"
                :invalid="titular.PersonTypeId == 2 && titular.CUIL == '' && submitted" />
            </template>

          </fieldset>
          <base-add-section label="Agregar inquilino" @click="addTitular" />
        </form>
        <div v-if="this.showRelatedTitularNeededMessage">
          Debe agregar al menos una persona fisica relacionada a la persona juridica.
        </div>

        <div class="empadronamiento__intro__button">
          <div></div>
          <button v-if="!loadingForm" class="active" @click="saveTitulars">Guardar</button>
          <button v-else disabled>Procesando ...</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { required, requiredIf } from 'vuelidate/lib/validators'
import moment from 'moment'

export default {
  data() {
    return {
      loading: true,
      loadingUnit: false,
      NeighborhoodId: 0,
      Units: [],
      submitted: false,
      loadingForm: false,
      showRelatedTitularNeededMessage: false
    };
  },
  created() {
    // Loguear al usuario
    this.$store.dispatch("logIn", this.$route.query.personToken)
      .then(() => {
        this.$store.dispatch("loggedIn", true);
        this.$store.dispatch("getEnums");
        this.$store.dispatch("getNeighborhoods");
        this.loading = false
      })
  },
  computed: {
    ...mapState({
      Enums: state => state.neighregistration.Enums,
      Neighborhoods: state => state.unit.Neighborhoods,
      RentModel: state => state.manageVecino.rentModel
    }),
    LegalTitulars() {

      return this.RentModel.Titulars.filter(t => t.PersonTypeId == 2).map(tr => ({ Id: tr.UniqueCode, Name: `${tr.FirstName} ${tr.LastName}` }));
    },
    MinToDate() {
      if (this.RentModel.ContractType == 1)
        return moment(this.RentModel.ContractDateFrom, "DD/MM/YYYY").add(30, 'days').format("DD/MM/YYYY");
      else
        return moment(this.RentModel.ContractDateFrom, "DD/MM/YYYY").add(90, 'days').format("DD/MM/YYYY");
    },
    MaxToDate() {
      if (this.RentModel.ContractType == 1)
        return moment(this.RentModel.ContractDateFrom, "DD/MM/YYYY").add(90, 'days').format("DD/MM/YYYY");
      else
        return '';
    }
  },
  methods: {
     onPersonTypeChange(prop, index) {
      if (this.RentModel.Titulars[index].PersonTypeId == 1) {
        //Fisica
        this.RentModel.Titulars[index].CUIL = "";
      }
      if (this.RentModel.Titulars[index].PersonTypeId == 2) {
        //Jurdica
        this.RentModel.Titulars[index].Identification = "";
      }
    },
    dateToIsInvalid() {
      let dateTo = moment(this.RentModel.ContractDateTo, "DD/MM/YYYY").format("YYYY-MM-DD")
      let dateFrom30 = moment(this.RentModel.ContractDateFrom, "DD/MM/YYYY").add(30, 'days').format("YYYY-MM-DD")
      let dateFrom90 = moment(this.RentModel.ContractDateFrom, "DD/MM/YYYY").add(90, 'days').format("YYYY-MM-DD")

      if (this.RentModel.ContractType == 1) {
        return dateTo < dateFrom30 || dateTo > dateFrom90
      }
      else {
        return dateTo < dateFrom90
      }
    },
    // IdentificationInvalid(){
    //   let dateTo = moment(this.RentModel.ContractDateTo,"DD/MM/YYYY").format("YYYY-MM-DD")
    //   let dateFrom30 = moment(this.RentModel.ContractDateFrom,"DD/MM/YYYY").add(30,'days').format("YYYY-MM-DD")
    //   let dateFrom90 = moment(this.RentModel.ContractDateFrom,"DD/MM/YYYY").add(90,'days').format("YYYY-MM-DD")

    //   if(this.RentModel.PersonTypeId == 1)
    //   {
    //     return dateTo < dateFrom30 || dateTo > dateFrom90
    //   }      
    //   else
    //   {
    //     return dateTo < dateFrom90
    //   }
    // },
    getUnits() {
      const self = this;
      this.loadingUnit = true;
      this.$store.dispatch("getUnits", this.NeighborhoodId).then(units => {
        self.Units = units;
        self.loadingUnit = false;
      });
    },
    addTitular() {
      this.$store.dispatch("addTitularRent")
      this.showRelatedTitularNeededMessage = false;

      const t = this.RentModel.Titulars;
      if (t.length === 2 && t[0] && t[0].PersonTypeId == 2) {
        this.$set(t[1], 'PersonTypeId', 1);
      }

      const relatedId = t[0] && (t[0].UniqueCode || t[0].Id);

      if (relatedId) {
        this.$set(t[1], 'RelatedLegalTitular', relatedId);
      }
    },
    isSecondPhysicalLocked(i) {
      const titulars = this.RentModel && this.RentModel.Titulars;
      const t0 = titulars && titulars.length > 0 ? titulars[0] : null;
      return !!(t0 && Number(t0.PersonTypeId) === 2 && i === 1);
    },

    saveTitulars() {
      this.submitted = true
      if (!this.$v.RentModel.$invalid && !this.dateToIsInvalid()) {
        if (this.RentModel.Titulars.filter(t => t.PersonTypeId == 1).length > 0) {
          this.loadingForm = true
          this.$store.dispatch("createRentProcedure")
        } else {
          //TODO: mostrar mensaje
          this.showRelatedTitularNeededMessage = true;
        }

      }

      else {
        setTimeout(() => {
          var element = document.querySelector(".empadronamiento__intro__main__form__container-item .has-error");
          if (element != null)
            element.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
        }, 0)
      }
    },
    deleteTitular(index) {
      this.$store.dispatch('removeTitularRent', index)
    },
    // Retorna true si el tipo de documento seleccionado es DNI (numérico)
    isDNI(identificationTypeId) {
      const types = this.Enums && this.Enums.IdentificationType;
      if (!types || !identificationTypeId) return true;
      const found = types.find(t => t.Id == identificationTypeId);
      return !found || found.Code === 'DNI' || found.Name === 'DNI';
    },
    // Normaliza el valor según el tipo: DNI quita puntos/guiones, pasaporte quita espacios/guiones y pone mayúsculas
    normalizeDoc(val, identificationTypeId) {
      if (this.isDNI(identificationTypeId)) {
        // DNI: solo digitos
        return val.replace(/\D/g, '');
      }
      // Pasaporte: solo letras y digitos, mayusculas
      return val.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    },
    // Retorna mensaje de error si el formato no es válido, null si es correcto
    docFormatError(val, identificationTypeId) {
      if (!val) return null;
      if (this.isDNI(identificationTypeId)) {
        return /^\d{7,8}$/.test(val) ? null : 'El DNI debe contener entre 7 y 8 dígitos.';
      }
      return /^[A-Z]{1,3}[0-9]{6,}$/.test(val) ? null : 'El pasaporte debe comenzar con 1 a 3 letras seguidas de numeros. Ej: AA123456';
    }
  },
  validations: {
    RentModel: {
      UnitId: {
        required
      },
      ContractType: {
        required
      },
      ContractDateFrom: {
        required
      },
      ContractDateTo: {
        required
      },
      Titulars: {
        $each: {
          FirstName: {
            required
          },
          LastName: {
            required
          },
          Email: {
            required
          },
          Phone: {
            required
          },
          IdentificationTypeId: {
            required
          },
          Identification: {
            required: requiredIf(prop => prop.PersonTypeId == 1),
            validFormat (val, titular) {
              if (titular.PersonTypeId != 1) return true;
              return !this.docFormatError(val, titular.IdentificationTypeId);
            }
          },
          CUIL: {
            required: requiredIf(prop => prop.PersonTypeId == 2)
          },
          PersonTypeId: {
            required
          }
        }
      }
    }
  }
};
</script>
